import { Component, Input, OnDestroy, Inject, Output, EventEmitter } from '@angular/core';
import { QuoteNote } from '../../models/quote.note.interface';
import { QuoteService } from '../../../quote/services/quote.service';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FileUpload } from '../../models/file.upload.interface';
import { finalize } from 'rxjs/operators';
import { QuoteBase } from '../../models/quote.base.interface';
import { FileService } from '../../services/file.service';
import {RolePermission } from '../../models/role.permission.enum';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../abstract.bidit.component';
import { NgForm } from '@angular/forms';

export interface DocumentDialogData extends QuoteNote {
  noteFile: any;
  messages: string[];
}

@Component({
  selector: 'app-project-documents',
  templateUrl: './project.documents.component.html',
  styleUrls: ['./project.documents.component.scss']
})
export class ProjectDocumentsComponent extends AbstractBiditComponent {
  errors: string;

  canEdit: boolean = true;

  documents: QuoteNote[] = new Array();

  private _quote: QuoteBase;

  constructor(private dialog: MatDialog, private fileService: FileService, private deviceDetectorService: DeviceDetectorService, private quoteService: QuoteService) {
    super(deviceDetectorService);
  }

  @Input()
  public set project(value: QuoteBase) {
    if (value) {
      this._quote = value;

      if (this._quote.quote_Converted != null)
        this.canEdit = QuoteService.hasPermission(RolePermission.EditJob);
      else if (this._quote.quote_IsLead)
        this.canEdit = QuoteService.hasPermission(RolePermission.EditLead);
      else
        this.canEdit = QuoteService.hasPermission(RolePermission.EditQuote);

      this.loadDocuments();
    }
  }

  @Output() updated = new EventEmitter<QuoteBase>();

  loadDocuments() {
    this.documents = this._quote.documents;
  }

  downloadAttachment(note: QuoteNote) {
    this.quoteService.getQuoteNoteAttachment(note.quoteNote_ID)
      .subscribe(x => {
        this.fileService.downloadFile(x, note.quoteNote_Attachment);
      });
  }

  deleteDocument(document: QuoteNote) {
    var proceed = confirm($localize`Delete the selected document?`);
    if (!proceed) return;

    this.quoteService.deleteQuoteNote(document.quoteNote_ID)
      .pipe(finalize(() => this.isRequesting = false))
      .subscribe(
        {next:(result) => {
          if (result) {
            this.updated.emit(this._quote);
          }
        },
        error: (error: string) => this.errors = error});
  }

  editDocument(document: QuoteNote) {
    const dialogRef = this.dialog.open(AddDocumentDialog, {
      width: '500px',
      data: document
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        console.log('The dialog was closed');
        if (result) {
          this.updated.emit(this._quote);
        }
      }
    });

  }

  addDocument() {
    const dialogRef = this.dialog.open(AddDocumentDialog, {
      width: '500px',
      data: {
        quote_ID: this._quote.quote_ID
      }
    });

    dialogRef.afterClosed().subscribe({
      next: (result) => {
        console.log('The dialog was closed');
        if (result) {
          this.updated.emit(this._quote);
        }
      }
    });

  }
}

@Component({
  selector: 'add.document.dialog',
  templateUrl: 'add.document.dialog.html',
})
export class AddDocumentDialog extends AbstractBiditComponent {

  fileBytes?: string;
  importFile?: any;

  constructor(
    deviceDetectorService: DeviceDetectorService,
    private quoteService: QuoteService,
    public dialogRef: MatDialogRef<AddDocumentDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DocumentDialogData) {
    super(deviceDetectorService);
  }

  addDocument(form: NgForm) {
    if (this.importFile == undefined && this.data.quoteNote_ID == null) {
      alert($localize`No file provided`);
      return;
    }

    if (form.valid) {
      let note = this.data as QuoteNote;

      this.isRequesting = true;
      if (this.importFile == undefined) {
        this.quoteService.saveQuoteNote(note)
          .pipe(finalize(() => this.isRequesting = false))
          .subscribe(
            {
              next: (result) => this.dialogRef.close(result),
              error: (error: string) => this.onError(error)
            });
      } else {
        this.saveDocumentAttachment(note);
      }
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  saveDocumentAttachment(note: QuoteNote) {
    // Set File Information
    note.attachment = {
      fileName: this.importFile.name,
      fileSize: this.importFile.size,
      fileType: this.importFile.type,
      lastModifiedTime: this.importFile.lastModified,
      lastModifiedDate: this.importFile.lastModifiedDate,
    } as FileUpload;

    this.isRequesting = true;

    note.attachment.fileAsBase64 = this.fileBytes;

      this.quoteService.saveQuoteNote(note)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe(
          {
            next: (result) => {
              if (result) {
                this.dialogRef.close(this.data);
              }
            },
            error: (error: string) => this.onError(error)
          });
  }
}
